var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.flipStatus,
      expression: "flipStatus"
    }],
    staticClass: "nodeInfo"
  }, [_c('div', {
    staticClass: "slideWrap"
  }, [_c('h3', {
    staticClass: "name",
    class: _vm.itemType.toLowerCase()
  }, [_vm._v(_vm._s(_vm.itemText))]), _vm._l(_vm.sortedProcessPropList.filter(function (prop) {
    return prop.active;
  }), function (prop, index) {
    var _Object$values$find, _prop$propertyVocabul, _prop$propertyClass, _prop$propertyClass2;

    return _c('div', {
      key: prop.processPropertyId,
      staticClass: "node_result_box"
    }, [_c('h4', {
      staticClass: "site_detail_tit"
    }, [_vm._v(" 속성명 : " + _vm._s(prop.propertyName) + " "), prop.propertyDefine != null && prop.propertyDefine != '' ? _c('div', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: `sidebar-collapse-${index}`,
        expression: "`sidebar-collapse-${index}`"
      }],
      staticClass: "tooltip_box",
      attrs: {
        "title": "속성설명을 보려면 클릭해주세요."
      }
    }, [_c('span', {
      staticClass: "tooltip_ico"
    })]) : _vm._e()]), _c('h4', {
      staticClass: "site_detail_con"
    }, [_vm._v("단위 : " + _vm._s(prop.propertyUnit != null && prop.propertyUnit != "" ? prop.propertyUnit : "없음") + " | 타입 : " + _vm._s(prop.propertyType != null ? (_Object$values$find = Object.values(_vm.PROPERTY_TYPE).find(function (item) {
      return item.value == prop.propertyType;
    })) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.label : "-") + " ")]), !_vm.strIsNull((_prop$propertyVocabul = prop.propertyVocabulary) === null || _prop$propertyVocabul === void 0 ? void 0 : _prop$propertyVocabul.code) ? _c('h4', {
      staticClass: "custom_site_detail_con"
    }, [_vm._v(" 어휘번호 : " + _vm._s(_vm.createViewVocabularyString(prop.propertyVocabulary)) + " ")]) : _vm._e(), !_vm.strIsNull((_prop$propertyClass = prop.propertyClass) === null || _prop$propertyClass === void 0 ? void 0 : _prop$propertyClass.name) ? _c('h4', {
      staticClass: "custom_site_detail_con"
    }, [_vm._v("class : " + _vm._s((_prop$propertyClass2 = prop.propertyClass) === null || _prop$propertyClass2 === void 0 ? void 0 : _prop$propertyClass2.name) + " ")]) : _vm._e(), prop.propertyDefine != null && prop.propertyDefine != '' ? _c('div', [_c('b-collapse', {
      staticClass: "mt-2",
      staticStyle: {
        "cursor": "default"
      },
      attrs: {
        "id": `sidebar-collapse-${index}`
      }
    }, [_c('b-card', {
      on: {
        "click": function ($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('p', {
      staticStyle: {
        "white-space": "pre-line",
        "text-align": "left",
        "font-size": "13px",
        "font-weight": "bold",
        "margin": "10px"
      }
    }, [_vm._v(" " + _vm._s(prop.propertyDefine))])])], 1)], 1) : _vm._e()]);
  }), _c('button', {
    staticClass: "flip",
    on: {
      "click": _vm.menuFlip
    }
  }, [_vm._v("접기")])], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }